<p-dropdown
  styleClass="pp-dd"
  [options]="options"
  [optionLabel]="optionLabel"
  [optionValue]="optionValue"
  [placeholder]="placeholder"
  [filter]="filter"
  [showClear]="showClear"
  [disabled]="disabled"
  [ngModel]="value"
  (ngModelChange)="onValueChange($event)"
  (onBlur)="onBlur()"
  appendTo="body">
</p-dropdown>
